export default "__VITE_ASSET__DrOjlwGI__";